export const FEATURE_NAME = '@zerops/zerops/core/first-class-recipe-base';

export enum FirstClassRecipeKeys {
  Elk = 'zeropsio/recipe-elk',
  Prometheus = 'zeropsio/recipe-prometheus-grafana'
}

/**
 * Represents the composition of services within an Elastic Stack project.
 * Used to determine which optional services (logstash, apm) are deployed.
 */
export type ElasticStackComposition =
  | 'none'      // No Elastic Stack services
  | 'base'      // Only base services (Elasticsearch + Kibana)
  | 'logstash'  // Base + Logstash only
  | 'apm'       // Base + APM Server only
  | 'both';     // Base + Logstash + APM Server

/**
 * Represents the composition of services within a Prometheus project.
 * Unlike Elastic Stack, Prometheus is either forwarding OR dedicated, not both.
 */
export type PrometheusComposition =
  | 'none'       // No Prometheus services or forwarding
  | 'forwarding' // Has forwarding service (global setup active)
  | 'dedicated'; // Has Prometheus + Grafana in project
